import React, { useState } from "react";
import "../../Styles/Modal.css";
import { getData } from "../../utils/store-data";
import {
  CLIENT_PROFILE_CODE,
  PROFILE_LOGIN,
  USER_ID,
} from "../../utils/store-data-constants";
import {
  get_profile_by_client_code,
  report_issue,
} from "../../api/serverWrapper";
import { IoChevronBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

function ReportIssueModal({ isOpen, onClose }) {
  const [issue, setIssue] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleReport = async () => {
    try {
      setIsSaving(true);

      const UserId = await getData(USER_ID);
      const loginType = await getData(PROFILE_LOGIN);

      const resp = await report_issue({
        UserId,
        ReportedIssue: issue,
      });

      if (resp?.code === 200) {
        setShowSuccess(true);
        setIssue("");
        setTimeout(() => {
          navigateToHome(loginType);
        }, 2000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSaving(false);
    }
  };

  const navigateToHome = async (isProfileLogin) => {
    if (isProfileLogin) {
      const code = await getData(CLIENT_PROFILE_CODE);
      const resp = await get_profile_by_client_code(code);

      if (resp?.data && resp.data.length > 0) {
        navigate("/profileforclient", {
          state: { client: resp.data[0] },
        });
      } else {
        navigate("/profileforclient");
      }
    } else {
      navigate("/dashboard");
    }

    onClose();
    setShowSuccess(false);
  };

  return (
    <div className="report-page-overlay">
      <div className="client-setup-header-main">
        <div className="client-setup-header-left">
          <IoChevronBackOutline
            className="client-setup-back-icon"
            onClick={() => {
              navigate("/dashboard");
              onClose();
            }}
          />

          <img
            src={require("../../assests/images/nav_bar_logo.png")}
            alt="Wedluk Logo"
            className="client-setup-logo"
          />
        </div>

        <div className="client-setup-header-right">
          <span> Report Issue</span>
        </div>
      </div>

      {showSuccess ? (
        <div className="report-success-container">
          <h3>Your concern has been Reported!</h3>

          <p>
            Thank you for letting us know. Our team will review the issue as
            soon as possible.
          </p>

          <div
            className="report-success-link"
            onClick={async () => {
              const loginType = await getData(PROFILE_LOGIN);
              navigateToHome(loginType);
            }}
          >
            Go back to home ➜
          </div>
        </div>
      ) : (
        <>
          <div className="report-page-card">
            <h3>Having Trouble?</h3>

            <p>
              Describe the issue you encountered so we can help resolve it
              quickly.
            </p>

            <textarea
              className="report-textarea"
              placeholder="How the issue typed will look"
              value={issue}
              maxLength={500}
              onChange={(e) => setIssue(e.target.value)}
            />

            <div className="report-footer">
              <span>{issue.length}/500</span>

              <button
                className="report-btn"
                disabled={isSaving}
                onClick={handleReport}
              >
                {isSaving ? "Reporting..." : "Report ›"}
              </button>
            </div>
          </div>{" "}
        </>
      )}
    </div>
  );
}

export default ReportIssueModal;
